import React, { useEffect, useState, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { PageTransition } from './components/PageTransition';
import { BackgroundBeams } from './components/ui/background-beams';
// Lazy load page components
const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ProgramsPage = lazy(() => import('./pages/ProgramsPage'));
const TeamPage = lazy(() => import('./pages/TeamPage'));
const TrainingCenterPage = lazy(() => import('./pages/TrainingCenterPage'));
const RoadmapPage = lazy(() => import('./pages/RoadmapPage'));
const SupportPage = lazy(() => import('./pages/SupportPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
// Loading component
const PageLoader = () => <div className="flex items-center justify-center min-h-screen bg-porcelain" data-id="element-0">
    <div className="animate-pulse text-israel-blue text-xl" data-id="element-1">Loading...</div>
  </div>;
// Scroll to top component
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-2">
      <Routes location={location} key={location.pathname} data-id="element-3">
        <Route path="/" element={<Suspense fallback={<PageLoader data-id="element-6" />} data-id="element-5">
              <PageTransition data-id="element-7">
                <HomePage data-id="element-8" />
              </PageTransition>
            </Suspense>} data-id="element-4" />
        <Route path="/about" element={<Suspense fallback={<PageLoader data-id="element-11" />} data-id="element-10">
              <PageTransition data-id="element-12">
                <AboutPage data-id="element-13" />
              </PageTransition>
            </Suspense>} data-id="element-9" />
        <Route path="/programs" element={<Suspense fallback={<PageLoader data-id="element-16" />} data-id="element-15">
              <PageTransition data-id="element-17">
                <ProgramsPage data-id="element-18" />
              </PageTransition>
            </Suspense>} data-id="element-14" />
        <Route path="/team" element={<Suspense fallback={<PageLoader data-id="element-21" />} data-id="element-20">
              <PageTransition data-id="element-22">
                <TeamPage data-id="element-23" />
              </PageTransition>
            </Suspense>} data-id="element-19" />
        <Route path="/training-center" element={<Suspense fallback={<PageLoader data-id="element-26" />} data-id="element-25">
              <PageTransition data-id="element-27">
                <TrainingCenterPage data-id="element-28" />
              </PageTransition>
            </Suspense>} data-id="element-24" />
        <Route path="/roadmap" element={<Suspense fallback={<PageLoader data-id="element-31" />} data-id="element-30">
              <PageTransition data-id="element-32">
                <RoadmapPage data-id="element-33" />
              </PageTransition>
            </Suspense>} data-id="element-29" />
        <Route path="/support" element={<Suspense fallback={<PageLoader data-id="element-36" />} data-id="element-35">
              <PageTransition data-id="element-37">
                <SupportPage data-id="element-38" />
              </PageTransition>
            </Suspense>} data-id="element-34" />
        <Route path="/contact" element={<Suspense fallback={<PageLoader data-id="element-41" />} data-id="element-40">
              <PageTransition data-id="element-42">
                <ContactPage data-id="element-43" />
              </PageTransition>
            </Suspense>} data-id="element-39" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <BrowserRouter data-id="element-44">
      <div className="w-full min-h-screen relative text-gray-800 font-display bg-porcelain" data-id="element-45">
        <BackgroundBeams data-id="element-46" />
        <div className="relative z-10" data-id="element-47">
          <ScrollToTop data-id="element-48" />
          <Navigation data-id="element-49" />
          <AnimatedRoutes data-id="element-50" />
          <Footer data-id="element-51" />
          {/* Sticky Donate Button - always visible */}
          <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 px-6 py-3 bg-israel-blue text-white font-semibold rounded-full hover:bg-israel-blue-light transition-all duration-300 shadow-lg hover:shadow-xl flex items-center gap-2" data-id="element-52">
            Donate Now
          </a>
        </div>
      </div>
    </BrowserRouter>;
}